import addStylesheet from "@/utils/addStylesheet";
import { generateCSSFromConfig } from "@/utils/cssGenerator"
import { FILTERS } from "@/enum/Filters";

export default function enableContrast(contrast: string) {
    const filter = FILTERS[contrast];

    if (!filter) {
        // Remove styles if no contrast is set
        document.getElementById('cya11y-filter-style')?.remove();
        document.body.classList.remove('cya11y-filter', 'cya11y-dark-contrast');
        return;
    }

    const css = generateCSSFromConfig({
        ...filter,
        selector: `*${filter.mainSelector}:not(#cya11y-container):not(#cya11y-container *):not(.cya11y-overlay):not(.cya11y-rg-container):not(.cya11y-rg-container *)`,
    });

    addStylesheet({ css, id: 'cya11y-filter-style' });
    document.body.classList.add('cya11y-filter');
    document.body.classList.toggle('cya11y-dark-contrast', contrast === 'dark-contrast');
}